import React from 'react';
import { ClipboardList } from 'lucide-react';
import { Button } from '../ui/button';
import { formatDateTime, getStatusColor, getPriorityColor } from './diningConstants';

export function ServiceRequestsSection({ serviceRequests, onManageRequest }) {
    return (
        <div className="space-y-6" data-testid="service-requests-section">
            <div>
                <h2 className="text-2xl font-bold">Service Requests</h2>
                <p className="text-muted-foreground">{serviceRequests.length} requests</p>
            </div>
            
            {/* Quick stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {['submitted', 'acknowledged', 'in_progress', 'completed'].map(status => (
                    <div key={status} className="bg-white rounded-xl p-4 border border-stone-200 text-center">
                        <p className="text-2xl font-bold text-stone-800">
                            {serviceRequests.filter(r => r.status === status).length}
                        </p>
                        <p className="text-sm text-stone-500 capitalize">{status.replace('_', ' ')}</p>
                    </div>
                ))}
            </div>
            
            {serviceRequests.length === 0 ? (
                <div className="bg-stone-100 rounded-xl p-12 text-center">
                    <ClipboardList className="w-12 h-12 text-stone-300 mx-auto mb-3" />
                    <p className="text-stone-500">No service requests yet</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {serviceRequests.map(request => (
                        <div key={request.id} className="bg-white rounded-xl p-4 border border-stone-200" data-testid={`service-request-${request.id}`}>
                            <div className="flex items-start justify-between">
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 flex-wrap mb-2">
                                        <span className="text-xs px-2 py-0.5 rounded-full bg-stone-100 text-stone-600 capitalize">
                                            {request.category?.replace('_', ' ')}
                                        </span>
                                        <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${getPriorityColor(request.priority)}`}>
                                            {request.priority}
                                        </span>
                                        <span className={`text-xs px-2 py-1 rounded-full capitalize ${getStatusColor(request.status, 'service')}`}>
                                            {request.status?.replace('_', ' ')}
                                        </span>
                                    </div>
                                    <h3 className="font-semibold text-stone-800">{request.title}</h3>
                                    {request.description && (
                                        <p className="text-sm text-stone-500 mt-1">{request.description}</p>
                                    )}
                                    <p className="text-xs text-stone-400 mt-2">
                                        Submitted {formatDateTime(request.created_at)} by {request.user?.email || request.user_email || 'Unknown'}
                                    </p>
                                    {/* Show notes if any */}
                                    {request.notes?.length > 0 && (
                                        <div className="mt-3 pt-3 border-t border-stone-100">
                                            <p className="text-xs font-medium text-stone-600 mb-1">Notes:</p>
                                            {request.notes.slice(-2).map((note, idx) => (
                                                <p key={idx} className="text-xs text-stone-500">
                                                    <span className="font-medium">{note.author}:</span> {note.note}
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <Button variant="outline" size="sm" onClick={() => onManageRequest(request)} data-testid={`manage-request-${request.id}`}>
                                    Update
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ServiceRequestsSection;
